import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DefaultDocument } from '@app/shared';
import { find } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { ManageDocumentsConfigService } from './shared/manage-documents.config.service';
import { ManageDocumentDataService } from './shared/manage-documents.data.service';

@Component({
  selector: 'iw-manage-documents',
  templateUrl: './manage-documents.component.html',
  styleUrls: ['./manage-documents.component.scss'],
  providers: [ManageDocumentDataService]
})
export class ManageDocumentsComponent implements OnInit {
  // Data de la tabla
  sourceData: LocalDataSource;
  // Contiene la configuracion de la tabla
  settings = {};
  // Contiene los documentos
  source: DefaultDocument[] = [];
  // contiene los documentos anulables
  documents: any[] = [];
  // contiene los documentos anulados
  annuledDocuments: any[] = [];
  // define si hay cambios en el arreglo de documentos para activar el botón de guardado
  changes: boolean = false;
  // contiene el id del trámite seleccionado
  @Input() tramite_id: number;
  // cierra la modal de documentos cuando se guarden los cambios
  @Output() savedDocs: EventEmitter<boolean> = new EventEmitter();

  constructor(private mdds: ManageDocumentDataService) { }

  ngOnInit() {
    const configTable = new ManageDocumentsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      this.actionTable(data);
    });
    this.mdds.getAnnuledDocuments(this.tramite_id).subscribe((data: any)=>{
      if(data){
        this.annuledDocuments = data.documentos;
        if(this.annuledDocuments.length){
          this.annuledDocuments.forEach(ad=>{
            this.documents.push(ad);
          })
        }
      }
    })
    this.mdds.getDefaultDocuments().subscribe(data => {
      if(data){
        this.source = data;
        this.loadingDocuments();
      }
    });
  }

  /**
   *Refresca los documentos anulados
   *
   * @memberof ManageDocumentsComponent
   */
  refreshDocs(){
    this.annuledDocuments = [];
    this.documents = [];
    this.mdds.getAnnuledDocuments(this.tramite_id).subscribe((data: any)=>{
      if(data){
        this.annuledDocuments = data.documentos;
        if(this.annuledDocuments.length){
          this.annuledDocuments.forEach(ad=>{
            this.documents.push(ad);
          })
        }
        this.loadingDocuments();
      }
    })
  }

   /**
    *Carga los documentos y setea la informacion
    *
    * @param {boolean} [refres=true]
    * @memberof ManageDocumentsComponent
    */
   loadingDocuments(refres: boolean = true) {
    this.source.forEach((sourceD: any) => {
      sourceD.associate = 'No';
    });

    if(this.annuledDocuments.length){
      this.source.forEach((sourceD: any)=>{
        this.annuledDocuments.forEach(d=>{
          if(d == sourceD.id){
            sourceD.associate = 'Sí';
          }
        })
      })
    }

    if (refres) {
      this.sourceData = new LocalDataSource(this.source);
    }
    this.sourceData.refresh();
  }

  /**
   *Controla la acción sobre los botones de la tabla
   *
   * @param {*} data
   * @memberof ManageDocumentsComponent
   */
  actionTable(data: any){
    switch(data.action){
      case 'asociar':
        this.associate(data.row);
        break;
      case 'eliminar':
        this.delete(data.row)
        break;
    }
  }

  /**
   *Aplica anulación 
   *
   * @param {*} data
   * @memberof ManageDocumentsComponent
   */
  associate(data: any){
    this.documents.push(data.id)
    this.source.forEach(d=>{
      if(d.id == data.id){
        d['associate'] = 'Sí'
      }
    })
    // número de documentos anulados existentes (para saber si hay algún cambio)
    let countExists = 0;
    let exist = find(this.annuledDocuments, {id: data.id})
    if(!exist){
      this.changes = true;
    }else{
      this.changes = false;
    }
    this.sourceData.refresh();
  }

  /**
   *No aplica anulación
   *
   * @param {*} data
   * @memberof ManageDocumentsComponent
   */
  delete(data: any){
    let index;
    this.documents.forEach((d,i)=>{
      if(d == data.id){
        index = i;
      }
    })
    this.source.forEach(d=>{
      if(d.id == data.id){
        d['associate'] = 'No'
      }
    })
    this.documents.splice(index,1);
    this.changes = true;
    this.sourceData.refresh();
  }

  saveDocuments(){
    this.mdds.annulDocuments(this.tramite_id, this.documents).then(res=>{
      if(res){
        this.refreshDocs();
        this.savedDocs.emit(true)
        this.changes = false;
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/manage-documents/manage-documents.component.ts